export enum NotificationKey {
  UNREAD_NOTIFICATIONS_COUNT = 'unreadNotificationsCount',
  NOTIFICATIONS_INFINITE = 'notificationsInfinite',
}
